module.exports = __webpack_public_path__ + "img/gp_logo_blue.17c76aa8.png";